// © Microsoft Corporation. All rights reserved.

// See https://webpack.js.org/guides/public-path/#on-the-fly for the details of __webpack_public_path__

import { headData } from "../app/HeadData";
import { UrlSearchParamsHelper, UrlUtility } from "../utilities";

declare var __webpack_public_path__: string;
const prodAssets = "//assets.msn.com";
const cnProdAssets = "//assets.msn.cn";

const ENV = {
    "microsoftnews.msn.com": prodAssets,
    "microsoftnews-int1.msn.com": prodAssets,
    "microsoftnews.msn.cn": cnProdAssets,
    "microsoftnews-int1.msn.cn": cnProdAssets,
    "microsoftnews-dev.msn.com": prodAssets,
    "ntp.msn.com": prodAssets,
    "ntp.msn.cn": cnProdAssets,
    "owa.msn.com": prodAssets,
    "www.msn.com": prodAssets,
    "www.msn.cn": cnProdAssets,
    "int1.msn.com": prodAssets,
    "int1.msn.cn": cnProdAssets,
    "int.msn.com": prodAssets,
    "int.msn.cn": cnProdAssets,
    "pagecomposition.msn.com": prodAssets,
    "pagecomposition-int.msn.com": prodAssets,
    "windows.msn.com": prodAssets,
    "windows.msn.cn": cnProdAssets,
    "windows-int1.msn.com": prodAssets,
    "windows-int1.msn.cn": cnProdAssets,
    "localhost:6000": prodAssets // for pcs local dev box
};

export const initializePublicPath = () => {
    if (ENV[window.location.host]) {
        // Combine query string params from HeadData with current query string param
        // to figure out what is the supported qsp is.
        // This is to solve qsp rewritten to PCS but client side have no qsp in address.
        const headDataQsp = headData.ClientSettings && headData.ClientSettings.queryparams;
        const searchParamStringLocation = (window.location.search || "").substring(1);
        const searchParamStringHeadData = (headDataQsp || "").substring(1);

        // Current query string param from client side has higher priority
        let combinedString = "?" + searchParamStringHeadData ? searchParamStringLocation + "&" + searchParamStringHeadData : searchParamStringLocation;
        combinedString = decodeURIComponent(combinedString);

        // For duplicate qsp keys, UrlSearchParamsHelper assumes first given, and other duplicates are ignored.
        const search = new UrlSearchParamsHelper(combinedString);
        const bundlesValue = search.get("bundles");

        // Item qsp supports multiple items. First value of the same key will be used.
        // Example, spalinkValue is rolling when qsp is item=test&item=spalink:rolling&item=spalink:123.45
        const itemParams = UrlUtility.getParamsWithItems(combinedString);
        const spalinkItem = itemParams.find(item => item.key === "spalink");
        const spalinkValue = spalinkItem && spalinkItem.value;
        const isRolling = spalinkValue === "rolling";

        if (spalinkItem && !isRolling) {
            __webpack_public_path__ = ENV[window.location.host] + __webpack_public_path__;
        } else {
            // default case without spalink override
            // in order to have the lazy chunk pointing to latest with a stable path, the build number will be overridden on runtime
            // PATHNAME: /bundles/v1/mmx/20190221.2/
            // PATHNAME.split("/"): ["", "bundles", "v1", "mmx", "20190221.2", ""]
            const segments = __webpack_public_path__.split("/");
            if (isRolling) {
                segments[4] = "rolling";
            } else if (bundlesValue) {
                segments[4] = bundlesValue;
            } else {
                segments[4] = "latest";
            }
            __webpack_public_path__ = ENV[window.location.host] + segments.join("/");
        }
    }
};

export const initializeHybridPublicPath = () => {
    const search = decodeURIComponent(window.location.search);
    if (search.indexOf("item=spa_env:localdev") > -1) {
        // Use active prime instance SPA directory for localdev
        __webpack_public_path__ = `//${window.location.host}/spa/`;
        return;
    }

    const host = ENV[window.location.host] || prodAssets;
    const isOverriden = search.indexOf("item=spalink:") > -1;
    if (isOverriden) {
        __webpack_public_path__ = host + __webpack_public_path__;
    } else {
        // default case without spalink override
        // in order to have the lazy chunk pointing to latest with a stable path, the build number will be overridden on runtime
        // PATHNAME: /bundles/v1/mmx/20190221.2/
        // PATHNAME.split("/"): ["", "bundles", "v1", "mmx", "20190221.2", ""]
        const segments = __webpack_public_path__.split("/");
        segments[4] = "latest";
        __webpack_public_path__ = host + segments.join("/");
    }
};
